import { render, staticRenderFns } from "./TenantEditDialog.vue?vue&type=template&id=eba4d012&scoped=true"
import script from "./TenantEditDialog.vue?vue&type=script&lang=ts"
export * from "./TenantEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./TenantEditDialog.vue?vue&type=style&index=0&id=eba4d012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba4d012",
  null
  
)

export default component.exports